import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";
import { OrganizationCrmHeaderContainerModel } from "../../../../../../models/aggregates/crm/organization";
@Injectable({
	providedIn: "root",
})
export class CrmOrganizationHdrService extends BaseApiTemplateService<OrganizationCrmHeaderContainerModel> {
	readonly url =
		Core2Config.DOMAIN_TEST_URL +
		Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX +
		"organizations-hdrs";

	constructor(http: HttpClient) {
		super();
		this.apiUrl =
			Core2Config.DOMAIN_TEST_URL +
			Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX +
			"organizations-hdrs";
		this.endpoint_path =
			Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX +
			"organizations-hdrs";
		this.httpClient = http;
	}
}
